import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { SubtitleVariants } from "./constants";
const { text, color } = ids || {};
const defaultStyle = css `
  color: ${color.text.heading.ids_color_text_heading_02};
`;
const onLight = css `
  color: ${color.contrast.ids_color_contrast_onLight_strong};
`;
const onDark = css `
  color: ${color.contrast.ids_color_contrast_onDark_strong};
`;
const getSubtitleVariantStyle = (variant, contrast) => {
    switch (variant) {
        case SubtitleVariants.default: {
            if (contrast === Contrast.dark)
                return onDark;
            if (contrast === Contrast.light)
                return onLight;
            return defaultStyle;
        }
        default:
            return defaultStyle;
    }
};
const StyledSubtitle = styled.div `
  ${{ ...text.head.ids_textStyle_subtitle_01 }};
  ${({ variant, contrast }) => getSubtitleVariantStyle(variant, contrast)}
`;
export default StyledSubtitle;
//# sourceMappingURL=Subtitle.style.js.map